import { VIZ_CATEGORICAL } from '@splunk/visualization-color-palettes';
import {
    COLOR_OR_TOKEN_PATTERN_WITH_RGBA,
    enhanceOptionsSchemaWithDynamicOptions,
    getPattern,
} from '../utils';

export const punchcardOptionsSchema = enhanceOptionsSchemaWithDynamicOptions({
    x: {
        default: '> primary | seriesByIndex(0)',
        description: 'Specify the dataSource applied to the x-axis.',
        type: 'array',
        items: { type: ['string', 'number'] },
    },
    y: {
        default: '> primary | seriesByIndex(1)',
        description: 'Specify the dataSource applied to the y-axis.',
        type: 'array',
        items: { type: ['string', 'number'] },
    },
    category: {
        default: '> primary | seriesByIndex(3)',
        description: 'Specify the dataSource to apply series categories.',
        type: 'array',
        items: { type: ['string', 'number'] },
    },
    size: {
        default: '> primary | seriesByIndex(2)',
        description: 'Specify the dataSource to apply bubble size in the chart.',
        type: 'array',
        items: { type: 'number' },
    },
    xField: {
        default: '> x | getField()',
        description: 'Specify the field that should be mapped to the x-axis.',
        type: 'string',
    },
    yField: {
        default: '> y | getField()',
        description: 'Specify the field that should be mapped to the y-axis.',
        type: 'string',
    },
    categoryField: {
        default: '> category | getField()',
        description: 'Specify the field that should be mapped to the series categories.',
        type: 'string',
    },
    sizeField: {
        default: '> size | getField()',
        description: 'Specify the field that should be mapped to the bubble size in the chart.',
        type: 'string',
    },
    backgroundColor: {
        default: '> themes.defaultBackgroundColor',
        description:
            'Specify the color used for the background. The default for enterprise light is "#ffffff". The default for enterprise dark is "#000000". The default for prisma dark is "#0b0c0e".',
        pattern: COLOR_OR_TOKEN_PATTERN_WITH_RGBA,
        type: 'string',
    },
    bubbleColor: {
        default: '> size | gradient(bubbleColorConfig)',
        description:
            'Specify the coloring method used for the bubbles when the colorMode “dynamic” is specified. For example “> size | gradient(bubbleColorConfig)".',
        type: ['string', 'array'],
    },
    bubbleLabelDisplay: {
        default: 'all',
        description:
            'Specify whether all bubble labels, the max value bubble labels, or none of the bubble labels should be displayed.',
        pattern: getPattern(['all', 'max', 'off']),
        type: 'string',
    },
    bubbleRadiusMax: {
        default: 15,
        description:
            'Specify the max radius (in pixels) of the bubbles when showDynamicBubbleSize option is false. Greater than 0.',
        type: 'number',
    },
    bubbleRadiusMin: {
        default: 1,
        description:
            'Specify the min radius (in pixels) of the bubbles when showDynamicBubbleSize option is false. Greater than 0.',
        type: 'number',
    },
    bubbleRowScale: {
        default: 'global',
        description: 'Specify how bubbles are scaled relative to other rows.',
        pattern: getPattern(['global', 'row']),
        type: 'string',
    },
    bubbleSizeMax: {
        default: 1,
        description:
            'Specify the max percentage (in decimal format) of space a bubble should take up within a cell when showDynamicBubbleSize option is true. The number specified must be between 0 and 1.',
        type: 'number',
    },
    bubbleSizeMin: {
        default: 0.25,
        description:
            'Specify the min percentage (in decimal format) of space a bubble should take up within a cell when showDynamicBubbleSize option is true. The number specified must be between 0 and 1.',
        type: 'number',
    },
    bubbleSizeMethod: {
        default: 'area',
        description: 'Specify whether bubble area or diameter corresponds to the size value.',
        pattern: getPattern(['radius', 'area']),
        type: 'string',
    },
    colorMode: {
        default: 'dynamic',
        description: 'Specify the coloring method used for the bubbles.',
        pattern: getPattern(['categorical', 'dynamic']),
        type: 'string',
    },
    legendDisplay: {
        default: 'right',
        description: 'Specify the location of the legend on the panel.',
        pattern: getPattern(['right', 'off']),
        type: 'string',
    },
    seriesColors: {
        default: VIZ_CATEGORICAL,
        description: 'Specify the colors used for a series. For example, "#FF0000", "#0000FF", "#008000".',
        type: 'array',
        items: {
            type: 'string',
        },
    },
    showDefaultSort: {
        default: false,
        description: 'Specify whether axes should be sorted based on order of time, digits and strings.',
        type: 'boolean',
    },
    showDynamicBubbleSize: {
        default: true,
        description: 'Specify whether the bubble size should be dynamic or fixed.',
        type: 'boolean',
    },
    showMaxValuePulsation: {
        default: true,
        description: 'Specify whether the max value bubble should pulsate.',
        type: 'boolean',
    },
});
